export var defaultBreakpoints = {
    xxxl: { width: 1920, items: 6 },
    xxl: { width: 1366, items: 4 },
    xl: { width: 1024, items: 4 },
    l: { width: 640, items: 2 },
    m: { width: 480, items: 2 },
    s: { width: 320, items: 1 }
};
//# sourceMappingURL=Carousel.constants.js.map